import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NetworkService {
    private onlineStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(navigator.onLine);

    constructor(private ngZone: NgZone) {
        // Listen to online and offline events
        window.addEventListener('online', () => this.updateOnlineStatus(true));
        window.addEventListener('offline', () => this.updateOnlineStatus(false));
    }

    // Update the status and run it within Angular's zone
    private updateOnlineStatus(status: boolean): void {
        this.ngZone.run(() => this.onlineStatus.next(status));
    }

    // Expose the status as an Observable
    get status$(): Observable<boolean> {
        return this.onlineStatus.asObservable();
    }

    // Optionally expose a method for immediate status check
    get isOnline(): boolean {
        return navigator.onLine;
    }
}
